<template>
  <accordion-simple-item title="API-Keys" :flex="true" v-if="userData?.isAdmin">

    <div class="flex flex-grow flex-col gap-2 overflow-hidden h-full">
      <button @click="navigateTo(`/administration/${accordionIndex}/createApiKey`)"
              class="p-1 bg-white w-full hover:bg-trader-blue hover:text-white"
              data-ui="create-new-user">API Key erstellen
      </button>
      <div class="flex flex-col gap-2  overflow-auto " data-ui="user-list">
        <div class="w-full p-1 " v-for="apiKey in this.apiKeys" :key="apiKey.id"
             :class="{ 'bg-trader-blue text-white': userId == apiKey.id, 'bg-trader-dark-gray': userId != apiKey.id }"
             @click="navigateTo(`/administration/${accordionIndex}/apiKey`, { id: apiKey.id })">
            <span class="w-full cursor-pointer" :data-ui="'open-username-dialog-' + apiKey.name">
              {{ apiKey.name }}</span>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>
<script>
import TRInput from "@/components/Base/v2/TRInput.vue";
import router from "@/router";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import {query} from "@/graphql";

export default {
  name: "SUser",
  data() {
    return {
      userSearch: "",
      apiKeys: [],
      userId: 0,
    }
  },
  props: {
    accordionIndex: {
      type: Number,
      default: 0
    },
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  computed: {
    ...mapState('user', ['userData']),

  },
  methods: {
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
    },
    async getAllUser() {
      const [apiKeys, err] = await query.getApiKeys()
      if (err) {
        console.error(err)
        return
      }

      this.apiKeys = apiKeys
      console.log(this.apiKeys)
    },
  },
  mounted() {
    this.getAllUser()
  },
  created() {
    this.userId = this.$route.params.userId
  },
  watch: {
    '$route.params.userId': function (newId, oldId) {
      this.userId = newId;
      this.getAllUser();
    },
  },
}
</script>